import {Component} from '@angular/core';

import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'gp-access-limited',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './access-limited.component.html',
  styleUrls: ['./access-limited.component.scss']
})
export class AccessLimitedComponent {}
